import axios from 'axios'

axios.defaults.baseURL = 'https://api.wedo.in.ua'

export default axios
